
import { DefaultStyle, SamplesVerifiedStyle, SamplesMissedStyle, SamplesHasLandsStyle } from "./features/map"
import Hash from './shared/Hash';

export const Config = {

    path: "/product/oksgeocoded/",

    metricModuleId: "OksGeocoded",

    texts: {
        appName: "Геокодированные ОКС",
        title: ['Геокодированный ЕГРН'],
        subtitle: ['Найдите недостающие координаты объектов', 'единого государственного реестра недвижимости'],
        textInfos: [
            {
                upper: '',
                title: 'Что это?',
                text: [
                    'Геокодированный и дополненный единый государственный реестр недвижимости (ЕГРН). В сведениях ЕГРН только 20-25% объектов капитального строительства (ОКС) имеют координаты.',
                    'Мы геокодируем, то есть привязываем к местности с точностью "до дома" еще для 30-50% - почти для всех, имеющих более-менее приличный адрес. '
                ]
            },
            {
                upper: '',
                title: 'Как работает?',
                text: [
                    'Основывается на технологии "Робот-картограф", соединяющей геоданные и адресные данные более чем из 10 источников, включая данные Единого государственного реестра недвижимости.',
                    'Это уже используется в прикладных задачах регионального управления и гармонизации данных ЕГРН:',
                    '- устранение дублей в ЕГРН;',
                    '- поиск объектов на местности и работа с собственниками;',
                    '- поиск связей ОКС и земельных участков;',
                    '- поиск связей между государственным адресным реестром и ЕГРН;',
                    '- повышение эффективности муниципального земельного контроля;',
                    '- планирование  и оценка возможной эффективности комплексных кадастровых работ;',
                    '- расчет ценообразующих факторов при государственной кадастровой оценке и пр.'
                ]
            },
            {
                upper: '',
                title: 'Как использовать?',
                text: [
                    '1. Проверить Ваш регион или муниципалитет, посмотреть статистику по найденным описанием, образец (пример) реальных данных по городу Самаре.',
                    '2. Оставить свои контакты и получить бесплатный фрагмент карты по Вашему городу или региону и бесплатную презентацию с техническими подробностями по его обработке.',
                    '3. Заказать полный набор данных и/или сервис.'
                ]
            }
        ],
        footer: {
            text: ['Всего по России 12.4 млн ОКС', 'получили координаты']
        },
        report: {
            button: "Отчет",
            header: "Отчет по территории",
            hint: "Оставьте свои контакты, мы свяжемся с вами",
            thanks: "Мы с вами свяжемся!",
            noRegionStub: "или обсудить любые другие вопросы",
            placeholder: "Почта или телефон",
            whereFromPlaceholder: "Откуда вы",
            request: "Запросить отчет"
        },
        drawing: {
            default: 'Проверить вашу территорию',
            start: 'Указать территорию',
            stop: 'Прекратить рисование'
        }
    },

    layers: [
        {
            id: "regions",
            label: "Регионы",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_166/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 1) && (p.properties_.countGeocoded > 0) ? DefaultStyle : undefined;
            },
            turned: true
        },
        {
            id: "municipalitets",
            label: "Муниципалитеты",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_166/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 2) && (p.properties_.countGeocoded > 0) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "settlements",
            label: "Поселения",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_166/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 3) && (p.properties_.countGeocoded > 0) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "samples",
            label: "Образец настоящих данных",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_167/{z}/{x}/{y}.pbf",
            maxZoom: 17,
            style: (p) => {
                if (p.properties_.baseOrigin === 'added') {
                    if (p.properties_.hasLands) {
                        return SamplesHasLandsStyle;
                    }
                    return SamplesMissedStyle;
                }
                return SamplesVerifiedStyle;
            },
            turned: false,
            afterTurned: (view) => {
                view.setCenter([5587958, 7016790]); //Самара
                //view.setCenter([5526139, 7507503]); //Казань
                view.setZoom(15);
            }
        }
    ],
    featureInfo: {
        properties: [
            {
                name: 'Всего ОКС в ЕГРН',
                field: "countTotal",
                unit: "шт",
                style: { fontSize: '30px' }
            },
            {
                name: 'Уже имели координаты в ЕГРН',
                field: (p) => { return p.countHasGeom ? p.countHasGeom + ' (' + (p.countHasGeom / p.countTotal * 100).toFixed(1) + '%)' : null; },
                style: { fontSize: '30px', color: '#E69138' }
            },
            {
                name: 'Нашли координаты (геокодировали)',
                field: (p) => { return p.countGeocoded ? p.countGeocoded + ' (' + (p.countGeocoded / p.countTotal * 100).toFixed(1) + '%)' : null; },
            },
            {
                name: 'В том числе: расположены на учтенном ЗУ',
                field: (p) => { return p.countHasLands ? p.countHasLands + ' (' + (p.countHasLands / p.countTotal * 100).toFixed(1) + '%)' : null; },
                style: { fontSize: '30px', color: '#3D79D8' }
            },
            {
                name: 'В том числе: вне ЗУ с координатами',
                field: (p) => {
                    let lost = p.countGeocoded - p.countHasLands;
                    if (lost > 0) {
                        return lost + ' (' + (lost / p.countTotal * 100).toFixed(1) + '%)';
                    } else {
                        return null
                    }
                },

                style: { fontSize: '30px', color: '#6AA84F' }
            },
            {
                name: 'Не удалось геокодировать',
                field: (p) => {
                    let lost = p.countTotal - p.countHasGeom - p.countGeocoded;
                    if (lost > 0) {
                        return lost + ' (' + (lost / p.countTotal * 100).toFixed(1) + '%)';
                    } else {
                        return null
                    }
                },
                style: { fontSize: '30px' }
            },
            { name: 'Вариантов координатного описания в среднем', field: "avgSourcesCount", round: 1, unit: "шт", style: { fontSize: '30px' } },
            //{ name: 'Средняя мера схожести', field: "avgSimilarity", round: 2 },         

            { name: 'Источник координат', field: (p) => { return (p.baseOrigin ? (p.baseOrigin === 'added' ? 'геокодирование' : 'ЕГРН') : undefined); }, style: { fontSize: '30px' } },
            { name: 'На земельном участке', field: (p) => { if ((p.baseOrigin === 'added') && (p.hasLands)) { return p.hasLands } return null; }, longText: true, style: { fontSize: '20px' } },
            {
                name: 'Вариантов координатного описания', field: (p) => {
                    if (p.geometryVariants) {
                        let variants = JSON.parse(p.geometryVariants);
                        return variants.length;
                    }
                },
                unit: "шт",
                style: { fontSize: '30px' }
            },
            //{ name: 'Мера схожести всех вариантов геометрии', field: "similarity", round: 2 }
        ],
        territoryNameFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? (properties.region + ', ' || '') + (properties.municipalitet || '') :
                    (properties.level === 3) ? (properties.region + ', ' || '') + (properties.municipalitet + ', ' || '') + (properties.settlement || '') :
                        (properties.region || '');
        },
        headerFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? properties.municipalitet :
                    (properties.level === 3) ? properties.settlement : properties.region;
        },
        subHeaderFunc: (properties) => {
            return properties.Address ? properties.Address :
                (properties.level === 2) ? properties.region :
                    (properties.level === 3) ? properties.municipalitet + ', ' + properties.region : '';;
        }
    },
    featureId: (feature) => {
        return Hash.SHA1((feature.properties_.ID || '') + (feature.properties_.region || '') + (feature.properties_.level || '') + (feature.properties_.municipalitet || '') + (feature.properties_.settlement || ''));
    }
}


